// ABOUTME: Pickup email template view on the relation Email settings page.
// ABOUTME: Thin wrapper around the shared EmailTemplateEditor; the mail tells a customer an order is ready at the warehouse.

import EmailTemplateEditor from "../../../../../components/global/EmailTemplates/EmailTemplateEditor";
import { UserPrivileges } from "../../../../../utils/permissions";

const Pickup = (props) => (
    <EmailTemplateEditor
        {...props}
        type="pickup"
        titleKey="pickup_email"
        managePrivileges={[UserPrivileges.RP_COMPANY_INFO_MANAGE]}
        showSubject
    />
);

export default Pickup;
